import moment from 'moment';
import { statuses } from 'constants/booking';

export const COMPLAINT_WINDOW = {
  OPEN: 'OPEN',
  NOT_YET_OPEN: 'NOT_YET_OPEN',
  CLOSED: 'CLOSED',
  UNAVAILABLE: 'UNAVAILABLE',
};

// Complaints may only be filed between the actual check-in and
// check-out times, not the whole calendar day (STU-300). Kept in
// sync with the API's strict window so we never show the entry point
// for a window the API will reject.
export const getComplaintWindow = (booking) => {
  if (!booking || booking.status !== statuses.PAID) return COMPLAINT_WINDOW.UNAVAILABLE;

  // moment(undefined) resolves to "now", so a missing timestamp would
  // silently satisfy the comparisons below and open the window. Fail
  // closed on anything unparseable instead.
  const checkIn = moment(booking.check_in || null);
  const checkOut = moment(booking.check_out || null);
  if (!checkIn.isValid() || !checkOut.isValid()) return COMPLAINT_WINDOW.UNAVAILABLE;

  const now = moment();
  if (now.isBefore(checkIn)) return COMPLAINT_WINDOW.NOT_YET_OPEN;
  if (now.isAfter(checkOut)) return COMPLAINT_WINDOW.CLOSED;
  return COMPLAINT_WINDOW.OPEN;
};

export const isComplaintEligible = (booking) =>
  getComplaintWindow(booking) === COMPLAINT_WINDOW.OPEN;
